<div class="wrapper">
  <app-product-list [products]="sellOrder?.skuGroups"></app-product-list>
  <mat-divider></mat-divider>
  <h3>Lista de históricos</h3>
  <section class="carousel-wrapper">
    <button class="carousel-arrow" (click)="carouselPrev()" [disabled]="!canScrollLeft">&#8249;</button>
    <section class="list-container" >
      <div class="card" *ngFor="let crate of sellOrder?.outOrderCrates; let i = index">
        <div class="header">
          <div class="value">Pallet {{ i + 1 }}</div>
        </div>
        <div class="details">
          <div class="line">
            <button mat-raised-button class="secondary-2" (click)="onCrateClick(crate.crateId)">Histórico</button>
          </div>
        </div>
      </div>
    </section>
    <button class="carousel-arrow" (click)="carouselNext()" [disabled]="!canScrollRight">&#8250;</button>
  </section>
</div>